/*
 * Created Date: Thu, 18th Feb 2021, 17:55:43 pm
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import React from 'react';
import PropTypes from 'prop-types';
import { CreateButton, useAuthenticated, useTranslate } from 'react-admin';
import { Search } from '@material-ui/icons';
import classnames from 'classnames';
import { accessDeniedStyles, actionButtonStyles } from 'styles';

export const EmptyResource = ({ buttonLabel, ...props }) => {
  const {
    className,
    classes: classesOverride,
    pageTitle,
    title,
    subtitle,
    basePath,
    ...rest
  } = props;
  const classes = accessDeniedStyles(props);
  const translate = useTranslate();
  const buttonClasses = actionButtonStyles();
  useAuthenticated();
  return (
    <div
      className={classnames(classes.container, className)}
      {...sanitizeRestProps(rest)}
    >
      <div className={classes.message}>
        <Search className={classes.icon} />
        <h1>{translate(`${title}`)}</h1>
        <div>{translate(subtitle)}</div>
      </div>
      {basePath && (
        <div className={classes.toolbar}>
          <CreateButton
            label={`actions.${buttonLabel || 'create'}`}
            variant="contained"
            basePath={basePath}
          />
        </div>
      )}
    </div>
  );
};

const sanitizeRestProps = ({
  staticContext,
  history,
  location,
  match,
  hasCreate,
  basePath,
  hasList,
  hasShow,
  hasEdit,
  ...rest
}) => rest;

EmptyResource.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  location: PropTypes.object,
};

export default EmptyResource;
